import { TOAST_DISPLAYED, NOTIFICATION_SENT } from '../../actions/types';

const initState = {
  messageAttempt: false,
  messageSuccess: false
};


export default function toastReducer(state=initState, action) {
  switch (action.type) {
    case TOAST_DISPLAYED:
      return {
        ...state,
        messageAttempt: false,
        messageSuccess: false
      }
      case NOTIFICATION_SENT:
        return {
          ...state,
          messageAttempt: true,
          messageSuccess: action.payload
        }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/alerts/toast_reducer.js